import React from 'react';
import CMSPage from '../../components/CMSPage.jsx';

export default function StudentDegree() {
  return (
    <CMSPage
      title="MS Degree Requirements"
      subtitle="Review program requirements and milestones."
      pageName="MS Plan"
      emptyMessage="Degree requirements have not been published yet."
    />
  );
}
